import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface TrialSlot {
  date: string;
  startTime: string;
  endTime: string;
}

export interface TrialScheduleWarning {
  date: string;
  message: string;
  classSchedule: { startTime: string; endTime: string };
  ghlSchedule: { startTime: string; endTime: string };
}

export interface GetAvailableTrialSlotsParams {
  classId: string;
  startDate: string;
  endDate: string;
}

export interface GetAvailableTrialSlotsResponse {
  slots: TrialSlot[];
  timezone?: string;
  scheduleWarnings?: TrialScheduleWarning[];
}

export const getAvailableTrialSlotsAPI = async (
  params: GetAvailableTrialSlotsParams,
) => {
  const response = await baseAPI.get<GetAvailableTrialSlotsResponse>(
    '/trialstudents/available-slots',
    { params },
  );
  return response.data;
};

export const useGetAvailableTrialSlots = (
  params: GetAvailableTrialSlotsParams | null,
) => {
  return useQuery({
    queryKey: [KEYS.STUDENTS, 'trial-slots', params],
    queryFn: () => getAvailableTrialSlotsAPI(params!),
    enabled: !!params?.classId && !!params?.startDate && !!params?.endDate,
  });
};
